export default __webpack_public_path__ + "static/media/618.29652726.png";